import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Modal } from 'semantic-ui-react';

const ErrorModal = (props) => {
    const isInitialMount = useRef(true);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");
    const routeHistory = useHistory();
    const routeLocation = useLocation();

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        }
        if (!!props.error && !!props.error.response) {
            setError(props.error.response);
            let error = props.error.response
            if(!!error.data && !!error.data.message)
                setMessage(error.data.message);
            else if(!!error.data && !!error.data.text)
                setMessage(error.data.text);
            else if(!!error.data && !!error.data.statusText)
                setMessage(error.data.statusText);
            else
                setMessage("");

        }
    },[props.open]);

    function handleOnSubmit() {
        setError(null);
        setMessage("");
        props.closeModals();
    }

    function handleClose() {
        props.closeModals();
    }

    const style = {
        header: {
            backgroundColor:"#303030",
            color:"white",
            fontSize: 24,
            textAlign: "center"
        },
        content:{
            fontSize: 15,
            backgroundColor:"#303030",
            color:"white"
        },
        actions: {
            backgroundColor:"#303030",
            color:"white"
        },
        title: {
            fontSize: 20,
            marginTop: 10
        },
        label:{
            color: "white"
        },
        name: {
            fontSize: 24
        },
        table: {
            main: {
                fontSize: 14,
                border: "1px solid #303030",
                color: "white",
                textAlign: "center"
            }
        }
    }

    return (
        <Modal
            open={props.open}
            onClose={props.closeModals}
            closeIcon
            size="tiny"
        >
            <Modal.Header style={style.header}>
                Error: {!!error ? error.status : ``}
            </Modal.Header>
            <Modal.Content style={style.content}>
            {
                (!!error) &&
                <div>
                    {message}
                </div>
            }
            </Modal.Content>
            <Modal.Actions style={style.actions}>
                <Button content="Close" onClick={handleClose} />
            </Modal.Actions>
        </Modal>
    )
}

ErrorModal.defaultProps = {
    open: false,
}

export default ErrorModal;